import { palette } from './palette';
import background from 'assets/images/faq-banner-large.webp';
import faqBanner from 'assets/images/faq-banner-medium.webp';
import savingsBackground from 'assets/images/savings-summary-banner.webp';
import findProviderBackground from 'assets/images/find-provider-banner.webp';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
    '& .disclosure_statement': {
      '@media screen and (max-width: 900px)': {
        paddingBottom: 48,
      },
      '@media screen and (max-width: 768px)': {
        paddingBottom: 64,
      },
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      '& .hero-shaped__left-side': {
        flex: '0 0 50%',
        maxWidth: '50%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '50vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.espire-container': {
    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.header,

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '550px',
      },
      '& .section-header': {
        '@media screen and (min-width: 768px)': {
          marginTop: '60px',
        },
      },
      '& .home-hero-title': {
        fontSize: '42px',
        color: palette.text.primary,
        maxWidth: '600px',
      },
      '@media screen and (max-width: 768px)': {
        '& .home-hero-title': {
          fontSize: '28px',
          color: palette.text.primary,
        },
      },
      '& .section-header__subtitle-wrapper': {
        margin: '12px 0px',
      },
      '& .home-hero-subtitle': {
        fontSize: '16px',
        maxWidth: 550,
      },
      '& .header': {
        fontWeight: 'bold',
      },
      '& .sub-header': {
        fontWeight: 500,
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '& .benefits-wrapper': {
        padding: '0 24px',

        '& .image': {
          borderRadius: 32,
        },

        '& .definition-service-tile': {
          padding: '0px 14px',
        },

        '& .definition-service-description ': {
          fontSize: 17,
          paddingBottom: 40,
          maxWidth: 390,
          margin: '0 auto',
        },

        '& .section-header': {
          paddingBottom: '70px',
        },

        '@media(max-width: 900px)': {
          '& .section-header': {
            paddingBottom: '20px',
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        backgroundColor: palette.text.primary,
      },
      '& .section-header__title, .section-header__subtitle, .subscription-tabs-label, .summary-text, .summary-subtext':
        {
          color: palette.text.highlight,
        },
      '@media screen and (max-width: 768px)': {
        '& .summary-text': {
          fontSize: '16px',
        },
      },
      '& #pricing-benefit-section': {
        '& .react-multi-carousel-dot button, & .react-multi-carousel-dot--active button': {
          background: palette.text.highlight
        },
        '& .planCard': {
          border: 'none',
          '&:hover': {
            background: palette.text.highlight,
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .maxAgeDisclaimer': {
            display: 'none',
          },
          '& .customcardTitle': {
            position: 'relative',
          },
          '& .customcardTitle svg': {
            position: 'absolute',
          },
          '& .price-value': {
            color: palette.primary.main,
            fontWeight: 'bold',
          },
          '& .disclaimerContainer': {
            '& .customUpfrontWrapper': {
              textAlign: 'left',
              paddingInline: '15px !important',
            },
          },
          '& .customBenefitsContainer': {
            '& .bold': {
              fontWeight: 500,
            },
          },
        },
        '& .select-plan-button': {
          '&:hover': {
            background: `${palette.primary.main} !important`,
          },
        },
        '@media(min-width: 900px)': {
          marginTop: 10,
        },

        '& .subscription-section': {
          '@media(min-width: 900px)': {
            marginTop: 10,
          },

          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'none',
          cursor: 'pointer',
          color: palette.primary.main,
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .how-cover-image': {
        height: 550,
      },
      '& .step-counter': {
        backgroundColor: palette.primary.main,
        fontSize: 16,
      },
      '& .step-content': {
        color: palette.text.light,
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-header': {
          color: palette.text.primary,
        },
      },
      '& .savings-contact-card': {
        background: palette.background.footer,
      },
      '& .faq-contact-section': {
        padding: '0 !important',
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, .find-provider-section, & .plan-selection-section, & .checkout-hero-section':
      {
        background: palette.background.header,
      },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: 'unset',
      },
      '& .hero-static-subtitle': {
        color: palette.text.light,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.main,
      '& .section-header__title-wrapper > h3': {
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '0px',
          left: '35%',
          height: '2px',
          width: '29%',
        },
      },
      '@media(min-width: 900px)': {
        padding: 22,
      },
      '& .MuiAvatar-root': {
        display: 'none',
      },
      '& .MuiTypography-colorTextPrimary': {
        textAlign: 'center',
      },
      '& .avatar-section': {
        paddingTop: '20px',
        order: 2,
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .section-header': {
        order: 1,
      },
      '& .MuiPaper-root': {
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .MuiRating-root': {
        marginTop: 'initial',
        order: 3,
      },
      '& .MuiPaper-rounded': {
        background: 'transparent',
      },
      '& .avatar-container': {
        padding: 0,
        marginBottom: '5px',
      },
      '& .testimonialSection': {
        padding: '40px 32px',
        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },
        '& .section-header__title': {
          fontWeight: '600 !important',
        },
        '& .testimonial-message': {
          fontSize: '18px',
          fontWeight: '400 !important',
          color: palette.text.light,
        },
        '& .testimonial-name': {
          display: 'flex',
          justifyContent: 'center',
          color: palette.text.light,
          fontWeight: '400 !important',
        },
        '& .react-multiple-carousel__arrow': {
          background: palette.text.primary,
        },
        '& .react-multi-carousel-dot--active button': {
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          background: `${palette.text.primary} !important`,
        },
        '& .react-multi-carousel-dot button': {
          width: '10px',
          height: '10px',
          borderRadius: '60%',
          background: palette.text.highlight,
        },
        '& .react-multi-carousel-item': {
          '& .MuiPaper-root': {
            marginInline: 100,
          },
          '& .custom-avatar': {
            display: 'none',
          },
          '@media(max-width: 900px)': {
            '& .MuiPaper-root': {
              marginInline: 0,
            },
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      backgroundImage: `url(${faqBanner})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',

      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
      },
      '& .hero-header-subtitle': {
        color: palette.text.light,
      },
      '& .header-container': {
        justifyContent: 'left',
        margin: '0',
      },
      '& .section': {
        marginLeft: 64,
      },
      '@media(max-width: 900px)': {
        '& .section': {
          marginLeft: 0,
        },
      },
    },
    '@media(min-width: 1700px)': {
      '& .faq-hero-section': {
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        height: '366px',
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: 'rgba(71, 86, 112, 0.8)',
      },
      '& .faq-link': {
        fontWeight: 'normal',
      },
    },
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .faq-contact-section': {
        '& .contact-img-wrapper': {
          width: '64px',
          maxWidth: '64px',
        },
        '& .contact-card-subtitle': {
          color: palette.text.light,
        },
        '& .provider-contact-details': {
          color: palette.text.secondary,
        },
        '& .provider-contact-link': {
          color: palette.text.primary,
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          background: palette.primary.light,
          color: palette.text.primary,
        },
      },
    },

    /* Find Provider Section */
    '& .find-provider-section, .plan-selection-section, .checkout-hero-section':
      {
        backgroundImage: `url(${findProviderBackground})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',

        '& .hero-header-title, .hero-header-subtitle': {
          margin: '0',
          textAlign: 'left',
        },
        '& .hero-header-subtitle': {
          color: palette.text.light,
        },
        '& .header-container': {
          justifyContent: 'left',
          margin: '0',
        },
        '& .section': {
          marginLeft: 64,
        },
        '@media(max-width: 900px)': {
          '& .section': {
            marginLeft: 0,
          },
        },
      },

    /* Savings Summary */
    '& .savings-hero-section': {
      backgroundImage: `url(${savingsBackground})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',

      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
      },
      '& .hero-header-subtitle': {
        color: palette.text.light,
      },
      '& .header-container': {
        justifyContent: 'left',
        margin: '0',
      },
      '& .section': {
        marginLeft: 64,
      },
      '@media(max-width: 900px)': {
        '& .section': {
          marginLeft: 0,
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-bg': {
          backgroundColor: palette.background.footer,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
      '& .primary-static-button': {
        background: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* Footer */
    '& .footer-wrapper, & .footer-wrapper a': {
      background: 'unset',
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },
  },
};
